import * as React from "react"
import { Global, css } from "@emotion/react"
import styled from "@emotion/styled"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #111111;
  color: #e2e8f0;
`

const Main = styled.main`
  flex: 1 0 auto;
`

const Footer = styled.footer`
  flex-shrink: 0;
  padding: 2rem;
  text-align: center;
  color: #64748b;
  font-size: 0.875rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif;
  background-color: #111111; /* Seamless blend */
`

const Layout = ({ children }) => {
  return (
    <Wrapper>
      <Global
        styles={css`
          html,
          body {
            margin: 0;
            padding: 0;
            background-color: #111111;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
              Helvetica, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }

          ::selection {
            background: rgba(99, 102, 241, 0.3);
            color: white;
          }
        `}
      />
      <Main>{children}</Main>
      <Footer>© {new Date().getFullYear()} Phillip Michalowski</Footer>
    </Wrapper>
  )
}

export default Layout
